import type {
  GenerateNotesApiRequest,
  GenerateNotesApiResponse,
  TryOnApiRequest,
  TryOnApiResponse
} from "./types";

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message);
  }
}

export async function requestTryOn(payload: TryOnApiRequest): Promise<TryOnApiResponse> {
  return postJson<TryOnApiResponse>("/api/tryon", payload);
}

export async function requestGeneratedNotes(
  payload: GenerateNotesApiRequest
): Promise<GenerateNotesApiResponse> {
  return postJson<GenerateNotesApiResponse>("/api/notes", payload);
}

async function postJson<T>(url: string, payload: unknown): Promise<T> {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const data = (await response.json().catch(() => null)) as { error?: string } | null;
  if (!response.ok) {
    throw new ApiError(data?.error ?? "生成失败，请稍后重试。", response.status);
  }

  return data as T;
}
